var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChildShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1784 3H15.8815C15.8815 8.62948 11.318 13.1931 5.68848 13.1931V23.3162C5.68848 43.6325 26.0047 49 26.0047 49C26.0047 49 46.3209 43.6325 46.3209 23.3162V13.1931C40.6915 13.1931 36.1278 8.62948 36.1278 3H30.593",
    fill: "url(#paint0_linear_7240_23857)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4224 16.6624C34.6442 16.1562 33.6177 16.3156 33.0224 17.0234C31.8833 18.3781 29.7364 20.3374 26.713 20.6093H25.288C22.2646 20.3374 20.1177 18.3781 18.9786 17.0234C18.3833 16.3109 17.3567 16.1562 16.5833 16.6577C15.6505 17.2671 15.4724 18.5609 16.2083 19.3952C17.3521 20.6984 19.2692 22.4421 21.9458 23.3984V23.4124V36.3218C21.9458 37.2452 22.6958 37.9952 23.6192 37.9952C24.5427 37.9952 25.2927 37.2452 25.2927 36.3218V31.0906H26.7271V36.3265C26.7271 37.2499 27.4771 37.9999 28.4005 37.9999C29.3239 37.9999 30.0739 37.2499 30.0739 36.3265V23.4171C30.0739 23.4124 30.0739 23.4077 30.0739 23.4031C32.7505 22.4468 34.6677 20.7031 35.8114 19.3999C36.5333 18.5609 36.3552 17.2671 35.4224 16.6624Z",
    fill: "url(#paint1_linear_7240_23857)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.001 19.9062C27.6319 19.9062 28.9541 18.5841 28.9541 16.9531C28.9541 15.3222 27.6319 14 26.001 14C24.37 14 23.0479 15.3222 23.0479 16.9531C23.0479 18.5841 24.37 19.9062 26.001 19.9062Z",
    fill: "#F98339"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_23857",
    x1: 10.7675,
    y1: 51.76,
    x2: 32.2807,
    y2: 0.452233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D9BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_23857",
    x1: 26.0042,
    y1: 16.3645,
    x2: 26.0042,
    y2: 37.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF842B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9867FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChildShield);
export default __webpack_public_path__ + "static/media/icon_child_shield.d3edc7893b89d7c49ee9956e2a2fc5f1.svg";
export { ForwardRef as ReactComponent };